import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableVirtuoso } from 'react-virtuoso';
import { List, ListItem, Divider, makeStyles } from '@material-ui/core';
import moment from 'moment';
import VehicleTablecell from './VehicleTablecell';
import { useNavigate } from 'react-router';
import { reportSubmenu, roadSubmenu, titleTableHeader } from './constance';
import { setTimeSearching } from 'src/features/deviceSlice';
import SearchIcon from '@material-ui/icons/Search';
import SettingsIcon from '@material-ui/icons/Settings';
import { Box, InputAdornment, TextField, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  menuItem: {
    padding: '8px 12px',
    transition: 'background-color 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  }
}));

const VehicleTableMini = ({ vehicles, getVehicle, idSelected, showSearch = true, total, extraCount = 0, baseDeviceCount }) => {
  const [rowActive, setRowActive] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [allVehicles, setAllVehicles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [menuPosition, setMenuPosition] = useState(null);

  const [submenuPosition, setSubmenuPosition] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [menuType, setMenuType] = useState([]);
  const [vehicleSub, setVehicleSub] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();

  const listVehicleTracking = useSelector(
    state => state.vehicleSlice?.listVehicleTracking || []
  );
  const expiredCount = listVehicleTracking.filter((v) => v.debt).length;
  const activeCount = baseDeviceCount !== undefined ? baseDeviceCount - expiredCount : 0;

  const isCamera4G =
    vehicleSub && (vehicleSub.device_type === 'VGPS_2CAM' || vehicleSub.vehicle?.device_type === 'VGPS_2CAM' || vehicleSub.device_type === 'VGPS_4CAM' || vehicleSub.vehicle?.device_type === 'VGPS_4CAM') ? true : false;
  const isCar4G =
    (vehicleSub && (vehicleSub.device_type === 'VGPS_2CAM' || vehicleSub.vehicle?.device_type === 'VGPS_2CAM' || vehicleSub.device_type === 'VGPS_4CAM' || vehicleSub.vehicle?.device_type === 'VGPS_4CAM')) ||
      (vehicleSub && (vehicleSub.device_type === 'VGPS_CAR4G' || vehicleSub.vehicle?.device_type === 'VGPS_CAR4G'))
      ? true
      : false;

  useEffect(() => {
    let filtered = [...vehicles];
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      filtered = filtered.filter(v => {
        const vData = v.vehicle || v;
        const name = vData?.name || '';
        const lp = vData?.license_plate || v.license_plate || '';
        return name.toLowerCase().includes(lowerSearch) ||
          lp.toLowerCase().includes(lowerSearch);
      });
    }

    const sortedVehicles = filtered.sort((a, b) => {
      if (a.debt && !b.debt) return 1;
      if (!a.debt && b.debt) return -1;
      const idA = a.device_id || a.id;
      const idB = b.device_id || b.id;
      return idB - idA;
    });
    setAllVehicles(sortedVehicles);
  }, [vehicles, searchTerm]);

  const virtuosoRef = React.useRef(null);
  const lastScrolledIdRef = React.useRef(null);

  useEffect(() => {
    if (idSelected !== undefined && idSelected !== null) {
      setRowActive(idSelected);

      if (idSelected !== lastScrolledIdRef.current) {
        const index = allVehicles.findIndex(v => {
          const vId = v.device_id || v.id;
          return String(vId) === String(idSelected);
        });

        if (index !== -1 && virtuosoRef.current) {
          virtuosoRef.current.scrollToIndex({
            index,
            align: 'center',
            behavior: 'smooth'
          });
          lastScrolledIdRef.current = idSelected;
        }
      }
    } else if ((idSelected === undefined || idSelected === null) && rowActive) {
      setRowActive(null);
      lastScrolledIdRef.current = null;
    }
  }, [idSelected, allVehicles]);

  const handleRowClick = vehicle => {
    setMenuPosition(null);
    const vId = vehicle.device_id || vehicle.id;
    if (vId === rowActive) {
      getVehicle(null);
    } else {
      getVehicle(vehicle);
    }
  };

  const handleClickMenu = (event, rowIndex, vehicle) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    let top = rect.bottom - 134;
    let left = rect.left + 38;

    setMenuPosition({ top, left });
    setVehicleSub(vehicle);
  };

  const handleCloseMenu = () => {
    setMenuPosition(null);
  };

  const handleSubmenuOpen = (event, type) => {
    const rect = event.currentTarget.getBoundingClientRect();
    let top = rect.top;
    let left = rect.right;
    setSubmenuPosition({ top, left });
    setSubmenuOpen(true);
    setMenuType(type === 'report' ? reportSubmenu : roadSubmenu);
  };

  const handleSubmenuClose = () => {
    setSubmenuOpen(false);
  };

  const handleQuickViewRoute = (e, menuItem) => {
    e.stopPropagation();

    if (menuItem.type === 'ROAD') {
      dispatch(
        setTimeSearching({
          id: vehicleSub.device_id || vehicleSub.id,
          license_plate: vehicleSub.license_plate || vehicleSub.vehicle?.license_plate,
          data: menuItem
        })
      );
    }

    navigate(`${menuItem.url}`);
    setMenuPosition(null);
  };

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {showSearch && (
        <Box style={{ padding: '8px 2px' }}>
          <Box display="flex" alignItems="center" style={{ marginBottom: '10px' }}>
            <Typography
              style={{
                fontSize: '14px',
                fontWeight: '600'
              }}
            >
              Danh sách thiết bị
            </Typography>
            {baseDeviceCount !== undefined && (
              <Typography
                style={{
                  fontSize: '14px',
                  fontWeight: '700',
                  marginLeft: '2px'
                }}
              >
                : ({activeCount}/{baseDeviceCount})
              </Typography>
            )}
          </Box>
          <Box display="flex" alignItems="center">
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="Tất cả thiết bị..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" color="action" />
                  </InputAdornment>
                ),
                style: { height: 32, fontSize: '13px' }
              }}
            />
          </Box>
        </Box>
      )}

      <TableVirtuoso
        ref={virtuosoRef}
        style={{ flex: 1, width: '100%' }}
        data={allVehicles}
        components={{
          Table: props => (
            <table
              {...props}
              style={{
                ...props.style,
                borderCollapse: 'collapse',
                border: '1px solid rgba(60, 64, 67, 0.15)',
                backgroundColor: '#f5f5f5',
                tableLayout: 'fixed',
                width: '100%'
              }}
            />
          ),
          TableRow: ({ item, ...props }) => {
            const vId = item.device_id || item.id;
            const isActive = vId === rowActive;
            const index = Number(props['data-index']);
            return (
              <tr
                {...props}
                onClick={() => handleRowClick(item, index)}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
                style={{
                  ...props.style,
                  borderBottom: '1px solid rgba(60, 64, 67, 0.15)',
                  cursor: 'pointer',
                  backgroundColor: isActive
                    ? '#ffe4e1'
                    : hoverIndex === index
                      ? '#ebebebff'
                      : 'transparent',
                  transition: 'background-color 0.15s linear',
                  willChange: 'background-color'
                }}
              />
            );
          }
        }}
        fixedHeaderContent={() => (
          <tr>
            {titleTableHeader.map(title => {
              return (
                <th
                  key={title.id}
                  style={{
                    width: title.width,
                    border: '1px solid rgba(60, 64, 67, 0.15)',
                    padding: '3px 0',
                    background: '#d9042f',
                    color: '#FFFFFF',
                    fontSize: '12px',
                    fontWeight: 500
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      whiteSpace: 'pre-line'
                    }}
                  >
                    {title.name}
                  </span>
                </th>
              );
            })}
          </tr>
        )}
        itemContent={(index, vehicle) => {
          const vData = vehicle.vehicle || vehicle;
          const displayText =
            vData?.is_display_name && vData?.name
              ? vData.name
              : (vData?.license_plate || `Device ${vehicle.device_id || vehicle.id}`);

          return (
            <>
              <td style={{ width: titleTableHeader[0].width, height: 38, overflow: 'hidden', padding: '0' }}>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    height: '100%',
                    alignItems: 'center'
                  }}
                >
                  <VehicleTablecell
                    row={vehicle}
                    index={index}
                    displayText={displayText}
                  />
                </div>
              </td>

              {vehicle.debt ? (
                <td
                  colSpan={2}
                  style={{
                    width: Number(titleTableHeader[1].width) + Number(titleTableHeader[2].width),
                    height: 38,
                    overflow: 'hidden',
                    padding: 0
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      height: '100%',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <span style={{ color: '#D9042F', fontSize: '11px', fontWeight: 500 }}>
                      Hết hạn gói dịch vụ
                    </span>
                  </div>
                </td>
              ) : (
                <>
                  <td
                    style={{
                      width: titleTableHeader[1].width,
                      height: 38,
                      overflow: 'hidden',
                      padding: '0'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <span style={{ fontSize: '12px' }}>
                        {Math.floor(vehicle.speed_gps) || 0}
                      </span>
                    </div>
                  </td>

                  <td
                    style={{
                      width: titleTableHeader[2].width,
                      height: 38,
                      overflow: 'hidden',
                      padding: '0'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: '6px',
                        paddingRight: '6px'
                      }}
                    >
                      <span style={{ fontSize: '11px' }}>
                        {vehicle
                          ? moment.unix(vehicle.created_at).format('DD/MM HH:mm:ss')
                          : '--'}
                      </span>

                      <div
                        style={{
                          cursor: 'pointer',
                          height: 16,
                          width: 15,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onClick={e => handleClickMenu(e, index, vehicle)}
                      >
                        <img alt="arrow" src="/static/iconSvg/arrow_right.svg" style={{ width: 8 }} />
                      </div>
                    </div>
                  </td>
                </>
              )}
            </>
          );
        }}
      />
      {menuPosition && (
        <div
          style={{
            position: 'fixed',
            top: menuPosition.top,
            left: menuPosition.left,
            backgroundColor: '#fff',
            boxShadow: '0px 2px 10px rgba(0,0,0,0.2)',
            zIndex: 9999,
            minWidth: '140px',
            borderRadius: '4px'
          }}
          onMouseLeave={() => {
            handleCloseMenu();
            handleSubmenuClose();
          }}
        >
          <List style={{ fontSize: '14px', padding: 0 }}>
            <ListItem
              className={classes.menuItem}
              onMouseEnter={e => handleSubmenuOpen(e, 'road')}
              style={{ padding: '5px 10px' }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                <span>Xem lộ trình</span>
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    height: '20px',
                    width: '20px'
                  }}
                >
                  <img alt="arrow" src="/static/iconSvg/arrow_right.svg" />
                </span>
              </div>
            </ListItem>

            <Divider />
            <ListItem
              className={classes.menuItem}
              onMouseEnter={e => handleSubmenuOpen(e, 'report')}
              style={{
                padding: '5px 10px',
                pointerEvents: !isCar4G ? 'none' : 'auto'
              }}
              disabled={!isCar4G}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}
              >
                <span>Báo cáo</span>
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    height: '20px',
                    width: '20px'
                  }}
                >
                  <img alt="arrow" src="/static/iconSvg/arrow_right.svg" />
                </span>
              </div>
            </ListItem>

            <Divider />
            <ListItem
              className={classes.menuItem}
              onClick={() => navigate('/app/image')}
              style={{ padding: '5px 10px' }}
              disabled={!isCamera4G}
            >
              <span>Xem hình ảnh</span>
            </ListItem>

            <Divider />
            <ListItem
              className={classes.menuItem}
              onClick={() => navigate('app/camera?page=1')}
              style={{ padding: '5px 10px' }}
              disabled={!isCamera4G}
            >
              <span>Xem lại video</span>
            </ListItem>
          </List>

          {submenuOpen && submenuPosition && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 141,
                backgroundColor: '#fff',
                boxShadow: '0px 1px 10px rgba(36, 36, 36, 0.2)',
                zIndex: 1000,
                minWidth: '200px',
                borderRadius: '4px'
              }}
              onMouseLeave={handleSubmenuClose}
              onMouseEnter={() => setSubmenuOpen(true)}
            >
              <List style={{ fontSize: '14px', padding: 0 }}>
                {menuType.map((item, index) => (
                  <React.Fragment key={index}>
                    <ListItem
                      className={classes.menuItem}
                      onClick={e => handleQuickViewRoute(e, item)}
                      style={{
                        padding: '5px 10px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <span>{item.name}</span>
                      {item.type === 'ROAD' && (
                        <span>
                          <img alt="clock" src="/static/iconSvg/clock_raw.svg" />
                        </span>
                      )}
                    </ListItem>
                    {index !== menuType.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            </div>
          )}
        </div>
      )}
    </Box>
  );
};

export default React.memo(VehicleTableMini);
